export default "__VITE_ASSET__f5d9970d__"